import type { FC } from "react";

import { useCartItems } from "@checkout-v2/shared";
import { useCurrency } from "@checkout-v2/shared/hooks/useCurrency";
import { useLoyaltyActiveStatus } from "@checkout-v2/shared/hooks/useLoyaltyActiveStatus";
import { useCheckoutV2Configuration } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";
import { checkIfMixedCart } from "@checkout-v2/shared/utils/checkIfMixedCart";
import { checkIfSubscriptionOrder } from "@checkout-v2/shared/utils/checkIfSubscriptionOrder";

import { useLoyaltyCampaignManagement } from "./hooks";
import { LoyaltyPointsView } from "./LoyaltyPointsView";

export const LoyaltyPointsContainer: FC = () => {
  const { data: cartItems } = useCartItems();
  const isLoyaltyActive = useLoyaltyActiveStatus();
  const isSubscription = checkIfSubscriptionOrder(cartItems);
  const isMixedCart = checkIfMixedCart(cartItems);
  const currency = useCurrency();
  const loyalty = useLoyaltyCampaignManagement();
  const checkoutConfiguration = useCheckoutV2Configuration();
  const redemptionTabSymbol = checkoutConfiguration.loyalty?.redemptionTabSymbol || "%";

  if (!isLoyaltyActive || (isSubscription && !isMixedCart) || !currency) return null;

  return (
    <LoyaltyPointsView
      currency={currency}
      userPoints={loyalty.userPoints}
      cartPoints={loyalty.cartPoints}
      loyaltyChoice={loyalty.loyaltyChoice}
      redemptionTabSymbol={redemptionTabSymbol}
      minVoucherCost={loyalty.minVoucherCost}
      maxVoucherValue={loyalty.maxVoucherValue}
      onCollect={loyalty.setCollect}
      onRedeem={loyalty.setRedeem}
      isRedeemAvailable={loyalty.isRedeemAvailable}
      vouchers={loyalty.vouchers}
      isQueryCampaign={loyalty.isQueryCampaign}
      isLoyaltyError={loyalty.isLoyaltyError}
      loyaltyCampaignId={loyalty.loyaltyCampaignId}
      onCampaignChange={loyalty.handleCampaignChange}
    />
  );
};
